// ********************************************************************************
// ID's used throughout the application to identify the countries.
// SEE: src/features/Checkout/hooks/useInamiCountries.js
export const USA_COUNTRY_ID = 57;
export const MEXICO_COUNTRY_ID = 115;